import styled from "styled-components";

export interface InputProps {
  type: "text" | "password" | "number" | "email" | "file" | "tel" | "date" | "time" | "datetime-local" | "none" | "textarea";
  name?: string;
  width?: string;
  height?: string;
  placeholder?: string;
  value?: string;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => void;
  register?: any;
}

interface InputStyleProps {
  $width: string;
  $height: string;
  $disabled: boolean;
  $isNone: boolean;
  $istextarea: boolean;
}

export default function Input({
  type,
  name,
  width = "13.125rem",
  height = "2rem",
  placeholder,
  value,
  disabled = false,
  onChange,
  register,
}: InputProps) {
  return (
    <>
      {type === "textarea" ? (
        <CommonInput
          as="textarea"
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange as React.ChangeEventHandler<HTMLTextAreaElement>}
          $width={width}
          $height={height}
          $disabled={disabled}
          $isNone={false}
          $istextarea={true}
        />
      ) : (
        <CommonInput 
          type={type === "none" ? "text" : type}
          name={name}
          placeholder={placeholder}
          value={value}
          disabled={disabled || type === "none"}
          onChange={onChange as React.ChangeEventHandler<HTMLInputElement>}
          $width={width}
          $height={height}
          $disabled={disabled}
          $isNone={type === "none"}
          $istextarea={false}
          {...register}
        />
      )}
    </>
  );
}

const CommonInput = styled.input<InputStyleProps>`
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height};
  padding-left: 0.625rem;
  padding-right: 0.5rem;
  border: ${({ $disabled, $isNone }) => $disabled || $isNone ? "none" : "1px solid #CED4DA"} ;
  border-radius: 0;

  ${({$istextarea}) => {
    switch ($istextarea) {
      case true: {
        return `
          resize: none;
          line-height: 1.5;
          word-break: break-all;
        `;
      }
    }
  }}

  &:disabled {
    background-color: ${({ $isNone }) => $isNone ? "#fff" : "#F1F1F1" };
  }

  &::-webkit-calendar-picker-indicator {
    padding: 0.2rem;
  }
`;
